<div id="page">
  <header id="more-imgs">
    <i class="fa fa-plus-circle fa-3x text-rose" (click)="addImageInput();"></i>
  </header>
  <div class="fileinput fileinput-new text-center mr-2" data-provides="fileinput">
    <div class="fileinput-new thumbnail">
      <img src="assets/dashboard/img/image_placeholder.jpg" alt="...">
    </div>
    <div class="fileinput-preview fileinput-exists thumbnail"></div>
    <div>
                          <span class="btn btn-rose btn-round btn-file">
                            <span class="fileinput-new">Select image</span>
                            <span class="fileinput-exists">Change</span>
                            <input type="file" name="image1" id="image1"
                                   accept=".gif, .jpg, .png" (change)="onFileSelected($event)"
                                   ngModel
                                   #selectImage="ngModel"
                                   required
                            />
                          </span>
      <a href="#pablo" class="btn btn-danger btn-round fileinput-exists" data-dismiss="fileinput"><i class="fa fa-times"></i> Remove</a>
    </div>
  </div>

  <div class="fileinput fileinput-new text-center mr-2" data-provides="fileinput">
    <div class="fileinput-new thumbnail">
      <img src="assets/dashboard/img/image_placeholder.jpg" alt="...">
    </div>
    <div class="fileinput-preview fileinput-exists thumbnail"></div>
    <div>
                          <span class="btn btn-rose btn-round btn-file">
                            <span class="fileinput-new">Select image</span>
                            <span class="fileinput-exists">Change</span>
                            <input type="file" name="image1" id="image2"
                                   accept=".gif, .jpg, .png" (change)="onFileSelected($event)"
                            />
                          </span>
      <a href="#pablo" class="btn btn-danger btn-round fileinput-exists" data-dismiss="fileinput"><i class="fa fa-times"></i> Remove</a>
    </div>
  </div>

   <!--End Page Wrap -->
</div>
<span class="text-danger" *ngIf="!selectImage.valid && selectImage.touched || this.control.submitted && !selectImage.valid">Au moins une image doit etre choisie !</span>




